import React from 'react';

import {formEncodedApi} from 'nutshell-core/api';

import {SlideshowContainer} from 'shells/carousel/slideshow-container';
import {Modal} from 'shells/modal/modal';

// @ts-expect-error
import getClassesMixin from '../mixins/get-classes';

// @ts-expect-error
import {SlideOne, SlideTwo, SlideThree, SlideFour} from './funnel';

type Props = {
    onDismiss: () => any;
};

type State = {
    isOpen: boolean;
};

export class OnboardingFunnelReportModal extends React.Component<Props, State> {
    getClasses = getClassesMixin;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isOpen: true,
        };
    }

    render() {
        const classes = this.getClasses('ui-modal--onboarding-funnel');
        const slides = [
            <SlideOne key={1} />,
            <SlideTwo key={2} />,
            <SlideThree key={3} />,
            <SlideFour key={4} />,
        ];

        return (
            <Modal className={classes} isOpen={this.state.isOpen} onClose={this.handleDismiss}>
                <SlideshowContainer showControls={false} onDismiss={this.handleDismiss}>
                    {slides}
                </SlideshowContainer>
            </Modal>
        );
    }

    handleDismiss = () => {
        formEncodedApi.post('/my-account/save-user-setting.json', {
            setting: 'has_viewed_onboarding_funnel',
            value: 1,
        });

        this.setState({isOpen: false});

        this.props.onDismiss();
    };
}
